import React from 'react'
import classNames from 'classnames'
import { CardProps, RailDetailsItem } from '@interfaces/index'
import { ImageSize } from '@enums/images.enum'
import { useImgUrlTransform } from '@hooks/useImgUrlTransform'
import { DocumentData } from 'firebase/firestore'
import Image from '@components/Image/Image'
import FallbackImage from '@components/FallbackImage/FallbackImage'
import './VerticalSimpleCard.scss'

interface VerticalSimpleCardProps {
  item: CardProps | RailDetailsItem | DocumentData
  isActive?: boolean
}

const VerticalSimpleCard = ({ item, isActive }: VerticalSimpleCardProps) => {
  const {
    title,
    contextData: { imagePoster },
  } = item
  const transformedImage = useImgUrlTransform(imagePoster, ImageSize.VERTICAL_CARD)

  return (
    <div
      className={classNames('vs-type', {
        'vs-type__full_opacity': isActive,
      })}
      data-testid="vs-type"
    >
      <div
        className={classNames('vs-type__focus', {
          'vs-type__focused': isActive,
        })}
      ></div>
      <div
        className={classNames(
          'card-image-wrapper vertical',
          { 'row-card-image-focused': isActive },
          { 'fallback-image': !imagePoster },
        )}
      >
        {imagePoster ? <Image image={transformedImage} alt={title} fallbackOnLoad /> : <FallbackImage />}
      </div>
    </div>
  )
}

export default VerticalSimpleCard
